import { useMutation } from '@apollo/client';
import { updateWorldMapMarkerCache } from 'cache/cacheUpdateMethods';
import {
    AddOrUpdateWorldMapMarker,
    AddOrUpdateWorldMapMarkerVariables
} from 'graphql/mutation/__generated__/AddOrUpdateWorldMapMarker';
import { ADD_OR_UPDATE_WORLD_MAP_MARKER } from 'graphql/mutation/worldMutation';
import { WorldMapStories_publishedStoriesForWorldMap } from 'graphql/query/__generated__/WorldMapStories';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';

export const useLinkStories = () => {
    const [setMarkerStories] = useMutation<
        AddOrUpdateWorldMapMarker,
        AddOrUpdateWorldMapMarkerVariables
    >(ADD_OR_UPDATE_WORLD_MAP_MARKER);
    const { getTokenForMapId } = useWorldMapLocalStorage();

    function link(
        allStories: WorldMapStories_publishedStoriesForWorldMap[],
        worldMapId: string,
        markerId: string,
        linkedStoryIds: string[]
    ) {
        const linkedStories = allStories.filter((e) => linkedStoryIds.includes(e.storyId));
        setMarkerStories({
            variables: {
                worldMapId: worldMapId,
                worldMapMarkerId: markerId,
                marker: {
                    storyIds: linkedStories.map((e) => e.storyId)
                },
                token: getTokenForMapId(worldMapId)
            },
            update: (cache, result) => {
                updateWorldMapMarkerCache(cache, {
                    stories: linkedStories,
                    ...result.data.addOrUpdateWorldMapMarker,
                    __typename: 'WorldMapMarker'
                });
            }
        });
    }

    return {
        link
    };
};
